import React from 'react';
import Box from './Box';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';


export default function FieldSwitch (props) {
  const { getValue, name, label, toggleBool, setTouch } = props;
  const value = getValue(name);
  return (
    <Box id={name}>
      <FormControlLabel
        control={
          <Switch
            checked={value}
            onBlur={setTouch(name)}
            onChange={toggleBool(name)}
            value={value}
            color="primary"
          />
        }
        label={label}
      />
    </Box>
  )
}
